export const removeRestrictedCharacters = (value) => {
  const pattern = /[<>\/\\\[\]\$\;\*]/g;

  return value.replace(pattern, '');
};